import { z } from 'zod';
export const SuccessLogoutDetailsSchema = z.object({
    return_to: z.string(),
    allowed_logout_url: z.string().array(),
    session_id: z.string(),
});
